<template>
  <div class="user" v-if="username">
    <span class="screen-name">
      <img
        v-if="source === 'instagram'"
        src="/static/Instagram_Logo_white.svg"
        class="icon instagram"
      />
      <img
        v-if="source === 'twitter'"
        src="/static/Twitter_Logo_WhiteOnImage.svg"
        class="icon twitter"
      />{{ prefixedUsername }}</span
    >
  </div>
</template>

<script>
export default {
  props: ['username', 'source'],

  computed: {
    prefixedUsername() {
      const prefix = this.source === 'twitter' ? '@' : '';
      return `${prefix}${this.username}`;
    }
  }
};
</script>
